import * as types from "../mutation-types";
const locale = "us";
const locales = ["us", "es"];
const Storage = window.localStorage;
// state
export const state = {
    // locale: Cookies.get("locale") || locale,
    locale: Storage.getItem("locale") || locale,
    locales: locales
};

// getters
export const getters = {
    locale: state => state.locale,
    locales: state => state.locales
};

// mutations
export const mutations = {
    [types.SET_LOCALE](state, { locale }) {
        state.locale = locale;
        Storage.setItem("locale", locale);
    }
};

// actions
export const actions = {
    setLocale({ commit }, { locale }) {

        if(locales.indexOf(locale) > -1) {
            commit(types.SET_LOCALE, { locale });
        }else{
            console.error(`Locale ${locale} not found`);
            commit(types.SET_LOCALE, { locale: locales[0] });
        }
    },
    test({ commit }, { locale }) {
        console.log(locale);
    }
};
